<template>
  <div class="signView" data-app>
    <v-sheet class="mainTitle" style="position: absolute; top: 3vh">
      <v-card-title style="font-size: 3vh; margin-bottom: 2vh">Nomad Map</v-card-title>
      <v-card-subtitle style="font-size: large">
        <div class="word-container">
          <span class="static-text">No More "Who's in </span>
          <transition name="rotate-fade" mode="out-in">
            <span :key="cityKey">{{ currentCity }}</span>
          </transition>
          <span class="static-text"> in </span>
          <transition name="rotate-fade" mode="out-in">
            <span :key="monthKey">{{ currentMonth }}</span>
          </transition>
          <span class="static-text">?"</span>
        </div>
      </v-card-subtitle>
    </v-sheet>
    <v-expand-transition>
        <v-card class="registrationCard" elevation="20" style="position: absolute; top: 25vh">
          <v-card-title>Reset Password</v-card-title>
          <div style="text-align: center">
            <v-form @submit.prevent="updatePassword">
              <v-text-field v-model="this.userEmail" type="email" placeholder="Email" disabled></v-text-field>
              <v-text-field v-model="resetPassword" type="password" placeholder="New Password"></v-text-field>
              <v-text-field v-model="repeatResetPassword" type="password" placeholder="Repeat New Password"></v-text-field>

              <v-btn type="submit" class="signInButton">Reset Password</v-btn>
            </v-form>
          </div>
        </v-card>
    </v-expand-transition>
    <v-alert transition="scroll-y-transition" dismissible v-model="badUpdateAlert" type="error" color="red" dense origin="top" class="registrationAlert">
      {{ this.badUpdateMessage }}
    </v-alert>

  </div>
</template>

<script>
import supabase from "@/lib/supabaseClient"
import Vue from 'vue'
import VueRouter from 'vue-router'
import {store} from "../store";
Vue.use(VueRouter)

export default {
  data() {
    return {
      googleClientId: null,
      cities: [" Bansko ", " Bali ", " Las Palmas ", " Sri Lanka ", " Albania ", " Thailand ", " Mexico "],
      months: [" January", " April"," September", " May", " July", " August", " March",  " June", " October", " November", " February", " December"],
      currentCityIndex: 0,
      currentMonthIndex: 5,
      cityKey: 0,
      monthKey: 0,
      repeatResetPassword: '',
      resetPassword: '',
      loading: false,
      badUpdateAlert: false,
      badUpdateMessage: null,
      resetPasswordErrorAlert: false,
      resetPasswordSuccessAlert: false,
      userEmail: ''
    };
  },
  computed: {
    store() {
      return store
    },
    currentCity() {
      return this.cities[this.currentCityIndex];
    },
    currentMonth() {
      return this.months[this.currentMonthIndex];
    },
  },

  async mounted() {
    this.startRotatingVariables();
    this.userEmail = (await supabase.auth.getUser()).data.user.email

  },
  methods: {
    async signUnValidateEmail() {
      let emailExists = await this.validateEmail(this.signupEmail)
      if (emailExists) {
        // Email already exists in the user list
        this.emailError = 'Email already taken';
        this.disableSignup = true
      } else {
        // Email is not in the user list
        this.emailError = ''
        this.disableSignup = false
      }
    },
    async validateEmail(emailToCheck) {
      try {
        let { data, error } = await supabase
            .from('users_data')  // Adjust if your table name is different
            .select('email')
            .eq('email', emailToCheck)

        if (error) throw error

        return data.length > 0

      } catch (error) {
        console.error('Error validating email:', error.message);
      }
    },
    startRotatingVariables() {
      setInterval(() => {
        this.cityKey++;
        this.monthKey++;
        this.currentCityIndex = (this.currentCityIndex + 1) % this.cities.length;
        this.currentMonthIndex = (this.currentMonthIndex + 1) % this.months.length;
      }, 3000); // Change variables every 1.5 seconds (adjust as needed)
    },

    async updatePassword() {
      if (this.resetPassword !== this.repeatResetPassword) {
        this.badUpdateMessage = 'Passwords do not match'
        this.badUpdateAlert = true
        return
      }
      try {

        const { data, error } = await supabase.auth.updateUser({
          password: this.repeatResetPassword,
        })

        this.loading = true

        if (error) throw error
        console.log(data)
        await this.$router.push('/');
      } catch (error) {
        if (error instanceof Error) {
          console.log(error)
/*
          alert(error)
*/
          this.badUpdateAlert = true
          this.badUpdateMessage = error.message
        }
      } finally {
        this.loading = false
      }
    },
  }
};
</script>

<style scoped>

.rotate-fade-enter-active,
.rotate-fade-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.rotate-fade-enter, .rotate-fade-leave-to /* .rotate-fade-leave-active in <2.1.8 */ {
  transform: rotateX(180deg);
  opacity: 0;
}


.rotatingText-adjective {
  animation: rotate-text-up 1.5s forwards;
  display: inline-block;
}

@keyframes rotate-text-up {
  0% {
    transform: translate3d(0, 10px, 0);
    opacity: 0;
  }

  25%, 75% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -10px, 0);
    opacity: 0;
  }
}
  .mainTitle {
    //position: absolute!important;
    top: 3vh;
    max-height: 70px;
    text-align: center;
    background: transparent;
  }
  .signView {
    font-family: 'Tisa Sans Pro', sans-serif !important;
  }
  .registrationAlert {
    top: 5vh;
    width: 75vw;
    text-align: center;
    position: fixed;
  }

  .app {
    display: flex;
    place-content: center;
    align-items: center;
    height: 100vh;
    font-family: 'Tisa Sans Pro', sans-serif !important;
  }
  .v-form {
    padding: 15px;
  }
  .v-sheet.v-card {
    border-radius: 15px;
  }

  .v-form {
    text-align: center;
  }

  .v-btn__content {
    color: aliceblue;
  }

</style>


<style>
.registrationCard {
  padding: 10px;
  opacity: 0.85;
  width: 80vw;
}
.signView {
  background: url("~@/assets/alberta-2297204_1920.webp") no-repeat fixed center;
  background-size: cover;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.signUpButton {
  margin-top: 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  padding: 0.9rem 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}

.signInButton {
  margin-top: 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  padding: 0.9rem 4rem;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
}


.signUpFooter {
  padding: 15px;
}

.googleLogo {
  margin-right: 16px;
  height: 24px;
  width: 24px;
}

.googleButton {
  text-transform: capitalize;
  margin: 3px;
}


.divider {
  border-top: 2px solid black;
  position: relative;
  margin-top: 26px;
  z-index: 0;
}

.divider p {
  position: absolute;
  top: -18px;
  left: 45%;
  z-index: 999;
  border-radius: 50%;
  padding: 5px;
  background: white;
}


</style>

